export default __webpack_public_path__ + "static/schematic-5c5123e629bee2227e7e5bb40c278326.svg";